/* ============ BKS LA BKS V2 — configurateur (moteur VELTO / FUSION, format « configurateurs V2 ») ============
   Généré par 17-bks-v2-fusion/make-labks.js — NE PAS modifier assets/bks-labks.js à la main.
     · zones      dessus (simili 12 couleurs + alcantara noir +50 €), côté, côté arrondi, surpiqûre, logo BKS
     · broderie   pseudo à l'arrière (+35 €), comme l'ancien configurateur LA BKS V2
     · modèles    = les variantes de la fiche produit (lues par Liquid : window.LABKS) ; chaque fiche par marque
                    ne montre donc que ses modèles
     · panier     selle + 1 ligne par option (produit « option-perso-labks »), rangées sous la selle (bloc commun V2)
   ============================================================================================================ */
(function(){
'use strict';

var L0 = window.LABKS || { handle:'', titre:'LA BKS V2 - Housse de selle', variantes:[] };

/* calques : chaque finition porte l'URL exacte de son calque (noms irréguliers sur le CDN) */
var FIN = {"cote-arrondi":[{"slug":"noir","nom":"Noir","matiere":"Simili","couleur":"noir","hex":"#3b3b3b","prix":0,"url":"https://cdn.shopify.com/s/files/1/0400/3086/3513/files/cote-arrondi-noir-labks.webp?v=1782488112"},{"slug":"blanc","nom":"Blanc","matiere":"Simili","couleur":"blanc","hex":"#d7d7d7","prix":0,"url":"https://cdn.shopify.com/s/files/1/0400/3086/3513/files/cote-arrondi-blanc-labks.webp?v=1782488106"},{"slug":"gris","nom":"Gris","matiere":"Simili","couleur":"gris","hex":"#6d6d6d","prix":0,"url":"https://cdn.shopify.com/s/files/1/0400/3086/3513/files/cote-arrondi-gris-labks.webp?v=1782488109"},{"slug":"rouge","nom":"Rouge","matiere":"Simili","couleur":"rouge","hex":"#c01a25","prix":0,"url":"https://cdn.shopify.com/s/files/1/0400/3086/3513/files/cote-arrondi-rouge-labks.webp?v=1782488112"},{"slug":"orange","nom":"Orange","matiere":"Simili","couleur":"orange","hex":"#cd6d0e","prix":0,"url":"https://cdn.shopify.com/s/files/1/0400/3086/3513/files/cote-arrondi-orange-labks.webp?v=1782488113"},{"slug":"jaune","nom":"Jaune","matiere":"Simili","couleur":"jaune","hex":"#cfb20d","prix":0,"url":"https://cdn.shopify.com/s/files/1/0400/3086/3513/files/cote-arrondi-jaune-labks.webp?v=1782488110"},{"slug":"vert","nom":"Vert","matiere":"Simili","couleur":"vert","hex":"#82c11b","prix":0,"url":"https://cdn.shopify.com/s/files/1/0400/3086/3513/files/cote-arrondi-vert-labks.webp?v=1782488118"},{"slug":"turquoise","nom":"Turquoise","matiere":"Simili","couleur":"turquoise","hex":"#1bb7c0","prix":0,"url":"https://cdn.shopify.com/s/files/1/0400/3086/3513/files/cote-arrondi-turquoise-labks.webp?v=1782488117"},{"slug":"bleu-clair","nom":"Bleu clair","matiere":"Simili","couleur":"bleu-clair","hex":"#2e92ad","prix":0,"url":"https://cdn.shopify.com/s/files/1/0400/3086/3513/files/cote-arrondi-bleu-clair-labks.webp?v=1782488104"},{"slug":"bleu","nom":"Bleu","matiere":"Simili","couleur":"bleu","hex":"#2d41ad","prix":0,"url":"https://cdn.shopify.com/s/files/1/0400/3086/3513/files/cote-arrondi-bleu-labks.webp?v=1782488104"},{"slug":"violet","nom":"Violet","matiere":"Simili","couleur":"violet","hex":"#871bc0","prix":0,"url":"https://cdn.shopify.com/s/files/1/0400/3086/3513/files/cote-arrondi-violet-labks.webp?v=1782488119"},{"slug":"rose","nom":"Rose","matiere":"Simili","couleur":"rose","hex":"#c01ba1","prix":0,"url":"https://cdn.shopify.com/s/files/1/0400/3086/3513/files/cote-arrondi-rose-labks.webp?v=1782488111"}],"cote":[{"slug":"noir","nom":"Noir","matiere":"Simili","couleur":"noir","hex":"#3b3b3b","prix":0,"url":"https://cdn.shopify.com/s/files/1/0400/3086/3513/files/cote-noir-labks.webp?v=1782488109"},{"slug":"blanc","nom":"Blanc","matiere":"Simili","couleur":"blanc","hex":"#d7d7d7","prix":0,"url":"https://cdn.shopify.com/s/files/1/0400/3086/3513/files/cote-blanc-labks.webp?v=1782488102"},{"slug":"gris","nom":"Gris","matiere":"Simili","couleur":"gris","hex":"#6d6d6d","prix":0,"url":"https://cdn.shopify.com/s/files/1/0400/3086/3513/files/cote-gris-labks.webp?v=1782488110"},{"slug":"rouge","nom":"Rouge","matiere":"Simili","couleur":"rouge","hex":"#c01a25","prix":0,"url":"https://cdn.shopify.com/s/files/1/0400/3086/3513/files/cote-rouge-labks.webp?v=1782488117"},{"slug":"orange","nom":"Orange","matiere":"Simili","couleur":"orange","hex":"#cd6d0e","prix":0,"url":"https://cdn.shopify.com/s/files/1/0400/3086/3513/files/cote-orange-labks.webp?v=1782488114"},{"slug":"jaune","nom":"Jaune","matiere":"Simili","couleur":"jaune","hex":"#cfb20d","prix":0,"url":"https://cdn.shopify.com/s/files/1/0400/3086/3513/files/cote-jaune-labks.webp?v=1782488107"},{"slug":"vert","nom":"Vert","matiere":"Simili","couleur":"vert","hex":"#82c11b","prix":0,"url":"https://cdn.shopify.com/s/files/1/0400/3086/3513/files/cote-vert-labks.webp?v=1782488119"},{"slug":"turquoise","nom":"Turquoise","matiere":"Simili","couleur":"turquoise","hex":"#1bb7c0","prix":0,"url":"https://cdn.shopify.com/s/files/1/0400/3086/3513/files/cote-turquoise-labks.webp?v=1782488114"},{"slug":"bleu-clair","nom":"Bleu clair","matiere":"Simili","couleur":"bleu-clair","hex":"#2e92ad","prix":0,"url":"https://cdn.shopify.com/s/files/1/0400/3086/3513/files/cote-bleu-clair-labks.webp?v=1782488107"},{"slug":"bleu","nom":"Bleu","matiere":"Simili","couleur":"bleu","hex":"#2d41ad","prix":0,"url":"https://cdn.shopify.com/s/files/1/0400/3086/3513/files/cote-bleu-labks.webp?v=1782488108"},{"slug":"violet","nom":"Violet","matiere":"Simili","couleur":"violet","hex":"#871bc0","prix":0,"url":"https://cdn.shopify.com/s/files/1/0400/3086/3513/files/cote-violet-labks.webp?v=1782488120"},{"slug":"rose","nom":"Rose","matiere":"Simili","couleur":"rose","hex":"#c01ba1","prix":0,"url":"https://cdn.shopify.com/s/files/1/0400/3086/3513/files/cote-rose-labks.webp?v=1782488112"}],"dessus":[{"slug":"noir","nom":"Noir","matiere":"Simili","couleur":"noir","hex":"#333333","prix":0,"url":"https://cdn.shopify.com/s/files/1/0400/3086/3513/files/dessus-noir-labks.webp?v=1782488124"},{"slug":"blanc","nom":"Blanc","matiere":"Simili","couleur":"blanc","hex":"#efefef","prix":0,"url":"https://cdn.shopify.com/s/files/1/0400/3086/3513/files/dessus-blanc-labks.webp?v=1782488121"},{"slug":"gris","nom":"Gris","matiere":"Simili","couleur":"gris","hex":"#767676","prix":0,"url":"https://cdn.shopify.com/s/files/1/0400/3086/3513/files/dessus-gris-labks.webp?v=1782488118"},{"slug":"rouge","nom":"Rouge","matiere":"Simili","couleur":"rouge","hex":"#d31918","prix":0,"url":"https://cdn.shopify.com/s/files/1/0400/3086/3513/files/dessus-rouge-labks.webp?v=1782488125"},{"slug":"orange","nom":"Orange","matiere":"Simili","couleur":"orange","hex":"#ec9110","prix":0,"url":"https://cdn.shopify.com/s/files/1/0400/3086/3513/files/dessus-orange-labks.webp?v=1782488124"},{"slug":"jaune","nom":"Jaune","matiere":"Simili","couleur":"jaune","hex":"#dad123","prix":0,"url":"https://cdn.shopify.com/s/files/1/0400/3086/3513/files/dessus-jaune-labks.webp?v=1782488123"},{"slug":"vert","nom":"Vert","matiere":"Simili","couleur":"vert","hex":"#87d418","prix":0,"url":"https://cdn.shopify.com/s/files/1/0400/3086/3513/files/dessus-vert-labks.webp?v=1782488127"},{"slug":"turquoise","nom":"Turquoise","matiere":"Simili","couleur":"turquoise","hex":"#18d2d3","prix":0,"url":"https://cdn.shopify.com/s/files/1/0400/3086/3513/files/dessus-turquoise-labks.webp?v=1782488126"},{"slug":"bleu-clair","nom":"Bleu clair","matiere":"Simili","couleur":"bleu-clair","hex":"#57a9cb","prix":0,"url":"https://cdn.shopify.com/s/files/1/0400/3086/3513/files/dessus-bleu-clair-labks.webp?v=1782488121"},{"slug":"bleu","nom":"Bleu","matiere":"Simili","couleur":"bleu","hex":"#383fc5","prix":0,"url":"https://cdn.shopify.com/s/files/1/0400/3086/3513/files/dessus-bleu-labks.webp?v=1782488122"},{"slug":"violet","nom":"Violet","matiere":"Simili","couleur":"violet","hex":"#9918d3","prix":0,"url":"https://cdn.shopify.com/s/files/1/0400/3086/3513/files/dessus-violet-labks.webp?v=1782488123"},{"slug":"rose","nom":"Rose","matiere":"Simili","couleur":"rose","hex":"#dc21bf","prix":0,"url":"https://cdn.shopify.com/s/files/1/0400/3086/3513/files/dessus-rose-labks.webp?v=1782488121"},{"slug":"alcantara-noir","nom":"Alcantara noir","matiere":"Alcantara","couleur":"noir","hex":"#333333","prix":50,"url":"https://cdn.shopify.com/s/files/1/0400/3086/3513/files/dessus-alcantara-noir-labks.webp?v=1782488124"}],"logobks":[{"slug":"noir","nom":"Noir","matiere":"Simili","couleur":"noir","hex":"#262626","prix":0,"url":"https://cdn.shopify.com/s/files/1/0400/3086/3513/files/logobks-noir-labks.webp?v=1782488127"},{"slug":"blanc","nom":"Blanc","matiere":"Simili","couleur":"blanc","hex":"#d8d8d8","prix":0,"url":"https://cdn.shopify.com/s/files/1/0400/3086/3513/files/logobks-blanc-labks.webp?v=1782488129"},{"slug":"gris","nom":"Gris","matiere":"Simili","couleur":"gris","hex":"#6d6d6d","prix":0,"url":"https://cdn.shopify.com/s/files/1/0400/3086/3513/files/logobks-gris-labks.webp?v=1782488131"},{"slug":"rouge","nom":"Rouge","matiere":"Simili","couleur":"rouge","hex":"#bd1f23","prix":0,"url":"https://cdn.shopify.com/s/files/1/0400/3086/3513/files/logobks-rouge-labks.webp?v=1782488129"},{"slug":"orange","nom":"Orange","matiere":"Simili","couleur":"orange","hex":"#c06020","prix":0,"url":"https://cdn.shopify.com/s/files/1/0400/3086/3513/files/logobks-orange-labks.webp?v=1782488128"},{"slug":"jaune","nom":"Jaune","matiere":"Simili","couleur":"jaune","hex":"#c0aa21","prix":0,"url":"https://cdn.shopify.com/s/files/1/0400/3086/3513/files/logobks-jaune-labks.webp?v=1782488127"},{"slug":"vert","nom":"Vert","matiere":"Simili","couleur":"vert","hex":"#9cbc1e","prix":0,"url":"https://cdn.shopify.com/s/files/1/0400/3086/3513/files/logobks-vert-labks.webp?v=1782488135"},{"slug":"turquoise","nom":"Turquoise","matiere":"Simili","couleur":"turquoise","hex":"#1fbf97","prix":0,"url":"https://cdn.shopify.com/s/files/1/0400/3086/3513/files/logobks-turquoise-labks.webp?v=1782488135"},{"slug":"bleu-clair","nom":"Bleu clair","matiere":"Simili","couleur":"bleu-clair","hex":"#1b91ba","prix":0,"url":"https://cdn.shopify.com/s/files/1/0400/3086/3513/files/logobks-bleu-clair-labks.webp?v=1782488124"},{"slug":"bleu","nom":"Bleu","matiere":"Simili","couleur":"bleu","hex":"#1a56ba","prix":0,"url":"https://cdn.shopify.com/s/files/1/0400/3086/3513/files/logobks-bleu-labks.webp?v=1782488128"},{"slug":"violet","nom":"Violet","matiere":"Simili","couleur":"violet","hex":"#801ebe","prix":0,"url":"https://cdn.shopify.com/s/files/1/0400/3086/3513/files/logobks-violet-labks.webp?v=1782488136"},{"slug":"rose","nom":"Rose","matiere":"Simili","couleur":"rose","hex":"#b91fb9","prix":0,"url":"https://cdn.shopify.com/s/files/1/0400/3086/3513/files/logobks-rose-labks.webp?v=1791784048"}],"base":[{"slug":"base","nom":"Base","matiere":"Simili","couleur":null,"hex":"#666","prix":0,"url":"https://cdn.shopify.com/s/files/1/0400/3086/3513/files/base-labks.webp?v=1782488137"}],"surpiqure":[{"slug":"noir","nom":"Noir","matiere":"Simili","couleur":"noir","hex":"#333333","prix":0,"url":"https://cdn.shopify.com/s/files/1/0400/3086/3513/files/surpiqure-noir-labks-v2_f188022c-5b0b-4774-b75a-20b39b52d758.webp?v=1791785645"},{"slug":"blanc","nom":"Blanc","matiere":"Simili","couleur":"blanc","hex":"#efefef","prix":0,"url":"https://cdn.shopify.com/s/files/1/0400/3086/3513/files/surpiqure-blanc-labks-v2_d6fd6ece-a355-4a1a-b7e6-f0c0fa4fa9e1.webp?v=1791785631"},{"slug":"gris","nom":"Gris","matiere":"Simili","couleur":"gris","hex":"#767676","prix":0,"url":"https://cdn.shopify.com/s/files/1/0400/3086/3513/files/surpiqure-gris-labks-v2_b960dba8-c697-453f-8626-5613f3ea89a6.webp?v=1791785639"},{"slug":"rouge","nom":"Rouge","matiere":"Simili","couleur":"rouge","hex":"#d31918","prix":0,"url":"https://cdn.shopify.com/s/files/1/0400/3086/3513/files/surpiqure-rouge-labks-v2_eeeed09a-a0bd-4cc4-b0c5-4e2f480ca125.webp?v=1791785655"},{"slug":"orange","nom":"Orange","matiere":"Simili","couleur":"orange","hex":"#ec9110","prix":0,"url":"https://cdn.shopify.com/s/files/1/0400/3086/3513/files/surpiqure-orange-labks-v2_26b0b02c-0ca6-4073-9173-2786a03b98a8.webp?v=1791785649"},{"slug":"jaune","nom":"Jaune","matiere":"Simili","couleur":"jaune","hex":"#dad123","prix":0,"url":"https://cdn.shopify.com/s/files/1/0400/3086/3513/files/surpiqure-jaune-labks-v2_2be31c14-3025-4b28-9883-a785bbc7df77.webp?v=1791785642"},{"slug":"vert","nom":"Vert","matiere":"Simili","couleur":"vert","hex":"#87d418","prix":0,"url":"https://cdn.shopify.com/s/files/1/0400/3086/3513/files/surpiqure-vert-labks-v2_66cd4af9-7d73-4159-a0c6-3f64a5930f28.webp?v=1791785663"},{"slug":"turquoise","nom":"Turquoise","matiere":"Simili","couleur":"turquoise","hex":"#18d2d3","prix":0,"url":"https://cdn.shopify.com/s/files/1/0400/3086/3513/files/surpiqure-turquoise-labks-v2_7b2480e5-2440-4927-bec4-36d1b6a7cceb.webp?v=1791785659"},{"slug":"bleu","nom":"Bleu","matiere":"Simili","couleur":"bleu","hex":"#383fc5","prix":0,"url":"https://cdn.shopify.com/s/files/1/0400/3086/3513/files/surpiqure-bleu-labks-v2_590d30f4-4a29-4cb1-9bf0-ebf7e4b89c28.webp?v=1791785634"},{"slug":"violet","nom":"Violet","matiere":"Simili","couleur":"violet","hex":"#9918d3","prix":0,"url":"https://cdn.shopify.com/s/files/1/0400/3086/3513/files/surpiqure-violet-labks-v2_fdf0cbe6-1dfb-48da-b195-154aa0816230.webp?v=1791785667"},{"slug":"rose","nom":"Rose","matiere":"Simili","couleur":"rose","hex":"#dc21bf","prix":0,"url":"https://cdn.shopify.com/s/files/1/0400/3086/3513/files/surpiqure-rose-labks-v2_9d2a8cbc-95c1-49d1-aa84-2be3704df23b.webp?v=1791785653"}]};
function urlCalque(zone, slug){ return fin(zone, slug).url || ''; }

var SCDN = 'https://cdn.shopify.com/s/files/1/0400/3086/3513/files/';

/* fil des BRODERIES — la palette de la FUSION */
var FILBROD = [
  ['Noir','#111111'],       ['Blanc','#f2f2f2'],     ['Gris','#8c8c8c'],
  ['Rouge','#e2231a'],      ['Orange','#e07b16'],    ['Jaune','#f7d000'],
  ['Doré','#d9a520'],       ['Vert','#3bbf2a'],      ['Turquoise','#1bb39a'],
  ['Bleu clair','#37a0e0'], ['Bleu','#1f4fd0'],      ['Violet','#7c3aed'],
  ['Rose','#e0249a']
];
function nomFilBrod(h){ for(var i=0;i<FILBROD.length;i++) if(FILBROD[i][1] === h) return FILBROD[i][0]; return h; }

/* ---------- modèles = variantes de la fiche ---------- */
var MODELES   = L0.variantes.map(function(v){ return v.t; });
var VARIANTES = L0.variantes.map(function(v){ return v.id; });

/* logo réseau social brodé devant le pseudo — offert, comme sur FUSION et VELTO (dessiné sur l'aperçu par bks-brod-social.js) */
var SOC = [['Aucun','aucun',''], ['TikTok','tiktok','social-tiktok'], ['Insta','insta','social-insta'], ['Snap','snap','social-snap']];
var SOC_IMG = 'https://cdn.shopify.com/s/files/1/0400/3086/3513/files/vl-';
function nomSoc(k){ for(var i=0;i<SOC.length;i++) if(SOC[i][1] === k) return SOC[i][0]; return ''; }
var PACK_VAR = 54119771603285;   /* pack entretien, repris de la Selle Custom */
var SUPP_HANDLE = 'supplement-selle-2d';   /* repli « brique » : l'ancien produit supplément de la LA BKS V2 */

/* ---------- prix ---------- */
/* le prix de la selle = celui de la variante du modèle choisi (sur une même fiche il peut varier :
   KTM 85 SX 99,90 €, les autres KTM 187,90 €) ; avant le choix du modèle : le plus bas de la fiche */
var PRIX = {
  base:    L0.variantes.length ? Math.min.apply(null, L0.variantes.map(function(v){ return v.p; })) / 100 : 187.90,
  brodNum: 20.00,   /* numéro / texte à l'avant (même prix que FUSION et VELTO) */
  brodPse: 35.00,
  pack:    17.82
};

/* position du pseudo (relevée avec positionner-broderie-labks.html) */
/* @@BROD@@ — positions relevées par Micka avec positionner-broderies-labks.html (12/10/2026) */
var BROD = {
  num: { left:22.0, top:24.3, taille:2.2, haut:2.3, rot:-23, max:14, lim:4 },   /* haut = étirement vertical */
  pse: { left:54.5, top:63.2, taille:1.8, haut:1.65, rot:30, max:22, lim:12 }
};

/* ---------- état ---------- */
var C = {
  modele:  '',
  dessus:  { s:'noir' },
  cote:    { s:'rouge' },
  arrondi: { s:'noir' },
  surpiqure:{ s:'rouge' },
  logo:    { s:'blanc' },
  social:  'aucun',
  brodNum: { t:'', c:'#f2f2f2' },
  brodPse: { t:'', c:'#f2f2f2' },
  pack:    false,
  touched: { modele:false, dessus:false, cotes:false, surpiqure:false, logo:false, brod:false }
};

var STEPS = [
  {ic:'🏍️',lb:'Ta moto'},  {ic:'🎨',lb:'Dessus'},   {ic:'🔻',lb:'Côtés'},
  {ic:'🪡',lb:'Surpiqûre'}, {ic:'🅱️',lb:'Logo'},     {ic:'🧵',lb:'Broderies'},
  {ic:'🧾',lb:'Récap'}
];

/* ---------- accès au catalogue ---------- */
function $(i){ return document.getElementById(i); }
function eur(n){ return n.toFixed(2).replace('.', ',') + ' €'; }
function liste(zone){ return (FIN && FIN[zone]) || []; }
function fin(zone, slug){
  var l = liste(zone);
  for(var i=0;i<l.length;i++) if(l[i].slug === slug) return l[i];
  return l[0] || { slug:slug, nom:slug, hex:'#666', prix:0, matiere:'Simili' };
}
function nomFin(zone, slug){ return fin(zone, slug).nom; }
function prixFin(zone, slug){ return fin(zone, slug).prix || 0; }
function valide(zone, slug){
  var l = liste(zone);
  for(var i=0;i<l.length;i++) if(l[i].slug === slug) return slug;
  return l.length ? l[0].slug : slug;
}
function vignette(o){
  if(o.matiere === 'Simili') return o.hex;
  return 'url(' + SCDN + 'fus-sw-' + o.matiere.toLowerCase() + '-' + o.couleur + '.webp) center/cover';
}
function mklabel(t){ var d = document.createElement('div'); d.className = 'lb'; d.textContent = t; return d; }
function touch(k){ C.touched[k] = true; }

function nuancier(zone, choisi, onpick){
  var w = document.createElement('div'); w.className = 'sws';
  liste(zone).forEach(function(o){
    var x = document.createElement('div'); x.className = 'swx';
    var s = document.createElement('div');
    s.className = 'sw' + (choisi === o.slug ? ' sel' : '');
    s.style.background = vignette(o);
    s.title = o.nom + (o.prix ? '  +' + eur(o.prix) : '');
    s.onclick = function(){ onpick(o.slug); };
    var l = document.createElement('div'); l.className = 'swlab';
    l.textContent = o.nom.replace(/^Alcantara\s+/, '');
    x.appendChild(s); x.appendChild(l);
    if(o.prix){ var p = document.createElement('div'); p.className = 'swlab';
                p.style.color = '#cdb6ff'; p.textContent = (o.matiere !== 'Simili' ? o.matiere + ' ' : '') + '+' + o.prix + '€'; x.appendChild(p); }
    w.appendChild(x);
  });
  return w;
}

/* ---------- prix ---------- */
function pDessus(){ return prixFin('dessus', C.dessus.s); }
function pBrodNum(){ return C.brodNum.t.trim() ? PRIX.brodNum : 0; }
function pBrodPse(){ return C.brodPse.t.trim() ? PRIX.brodPse : 0; }
function pPack(){ return C.pack ? PRIX.pack : 0; }
function total(){ return prixSelle() + pDessus() + pBrodNum() + pBrodPse() + pPack(); }
function prixSelle(){ var i = MODELES.indexOf(C.modele); return (i >= 0 && L0.variantes[i].p) ? L0.variantes[i].p / 100 : PRIX.base; }
function variante(){ var i = MODELES.indexOf(C.modele); return i < 0 ? 0 : VARIANTES[i]; }

/* ---------- aperçu ---------- */
function paint(){
  function set(id, zone, slug){
    var e = $(id), u = urlCalque(zone, slug);
    if(!u){ e.style.display = 'none'; return; }
    if(e.getAttribute('src') === u){ e.style.display = ''; return; }
    var pre = new Image();
    pre.onload  = function(){ e.src = u; e.style.display = ''; };
    pre.onerror = function(){ e.style.display = 'none'; };
    pre.src = u;
  }
  set('L_base',      'base',         'base');
  set('L_arrondi',   'cote-arrondi', C.arrondi.s);
  set('L_cote',      'cote',         C.cote.s);
  set('L_dessus',    'dessus',       C.dessus.s);
  set('L_surpiqure', 'surpiqure',    C.surpiqure.s);
  set('L_logo',      'logobks',      C.logo.s);
  peindreBrod('B_num', BROD.num, C.brodNum);
  peindreBrod('B_pse', BROD.pse, C.brodPse);

  $('wm').textContent = C.modele ? C.modele.split(' ')[0].toUpperCase() : 'LA BKS';
  var t = eur(total());
  $('fly').textContent = t;
  var tv = $('tot');
  if(tv.textContent !== t){ tv.textContent = t; tv.classList.add('bump');
    setTimeout(function(){ tv.classList.remove('bump'); }, 200); }
  $('stp').textContent = 'Étape ' + (cur+1) + '/' + STEPS.length;
  $('bn').textContent  = (cur === STEPS.length-1) ? '🛒 Ajouter au panier' : 'Suivant →';

  var pl = $('pills'); pl.innerHTML = '';
  STEPS.forEach(function(s, i){
    var b = document.createElement('button');
    b.className = 'pill' + (i === cur ? ' act' : '') + (stepDone(i) ? ' done' : '');
    b.innerHTML = s.ic + ' ' + s.lb;
    b.onclick = function(){ cur = i; render(); };
    pl.appendChild(b);
  });
  if(pl.children[cur]){
    if(!pl.dataset.molette){
      pl.dataset.molette = '1';
      pl.addEventListener('wheel', function(e){
        if(pl.scrollWidth <= pl.clientWidth) return;
        var d = Math.abs(e.deltaY) > Math.abs(e.deltaX) ? e.deltaY : e.deltaX;
        if(!d) return;
        pl.scrollLeft += d; e.preventDefault();
      }, { passive:false });
    }
    centrerPastille();
  }
}
function centrerPastille(){
  var pl = $('pills'), act = pl && pl.children[cur];
  if(!act) return;
  var maxi = pl.scrollWidth - pl.clientWidth;
  pl.classList.toggle('defile', maxi > 0);
  if(maxi > 0){
    var rb = pl.getBoundingClientRect(), ra = act.getBoundingClientRect();
    var vise = pl.scrollLeft + (ra.left - rb.left) - (pl.clientWidth - ra.width) / 2;
    pl.scrollLeft = Math.max(0, Math.min(maxi, vise));
  } else pl.scrollLeft = 0;
  majRail();
}

/* ---------- broderie ---------- */
function fitBrod(el, taille, maxPct){
  var L = $('stage').clientWidth || 520;
  el.style.fontSize = (taille/100*L) + 'px';
  var w = el.scrollWidth, maxPx = maxPct/100*L;
  if(w > maxPx) el.style.fontSize = ((taille*maxPx/w)/100*L) + 'px';
}
function peindreBrod(id, pos, etat){
  var el = $(id), t = (etat.t||'').trim();
  if(!t){ el.style.display = 'none'; return; }
  el.textContent = t.slice(0, pos.lim);
  el.setAttribute('style', 'display:block;left:' + pos.left + '%;top:' + pos.top + '%;'
    + 'transform:translate(-50%,-50%) rotate(' + pos.rot + 'deg) scaleY(' + (pos.haut || 1) + ');'
    + 'color:' + etat.c + ';text-shadow:0 1px 2px rgba(0,0,0,.5);');
  fitBrod(el, pos.taille, pos.max);
}
function refitBrod(){ peindreBrod('B_num', BROD.num, C.brodNum); peindreBrod('B_pse', BROD.pse, C.brodPse); }
window.addEventListener('resize', function(){ refitBrod(); centrerPastille(); });
if(document.fonts && document.fonts.ready) document.fonts.ready.then(refitBrod);

/* ---------- barre de défilement des étapes ---------- */
function majRail(){
  var pl = $('pills'), w = $('railwrap'), th = $('rthumb');
  if(!pl || !w || !th) return;
  var maxi = pl.scrollWidth - pl.clientWidth;
  w.classList.toggle('on', maxi > 0);
  if(maxi <= 0) return;
  var rail = th.parentNode.clientWidth;
  var larg = Math.max(26, Math.round(rail * pl.clientWidth / pl.scrollWidth));
  th.style.width = larg + 'px';
  th.style.left  = Math.round((rail - larg) * (pl.scrollLeft / maxi)) + 'px';
}
(function(){
  var pl = $('pills'), rail = $('rthumb') && $('rthumb').parentNode;
  if(!pl || !rail) return;
  pl.addEventListener('scroll', majRail, { passive:true });
  window.addEventListener('resize', majRail);
  var tire = false;
  function aller(e){
    var t = e.touches ? e.touches[0] : e;
    var r = rail.getBoundingClientRect();
    var k = Math.max(0, Math.min(1, (t.clientX - r.left) / r.width));
    pl.scrollLeft = k * (pl.scrollWidth - pl.clientWidth);
  }
  rail.addEventListener('pointerdown', function(e){ tire = true; aller(e); });
  window.addEventListener('pointermove', function(e){ if(tire) aller(e); });
  window.addEventListener('pointerup', function(){ tire = false; });
})();

/* ---------- rendu des étapes ---------- */
var cur = 0;

function render(){
  var y = window.scrollY;
  var p = $('pane'); p.innerHTML = '';

  if(cur === 0){
    p.innerHTML = '<h2>Ta moto 🏍️</h2>'
                + '<div class="sub">On découpe la housse au patron exact de ton modèle. Rien à nous envoyer : on fabrique une housse neuve.</div>';
    p.appendChild(mklabel('Modèle'));
    var sel = document.createElement('select');
    sel.innerHTML = '<option value="">— choisis ton modèle —</option>'
      + MODELES.map(function(m){ return '<option' + (C.modele === m ? ' selected' : '') + '>' + m + '</option>'; }).join('');
    sel.onchange = function(){ C.modele = this.value; touch('modele'); render(); };
    p.appendChild(sel);
    var n = document.createElement('div'); n.className = 'note';
    n.textContent = 'Tu ne trouves pas ta moto ? Écris-nous, on fabrique sur mesure.';
    p.appendChild(n);
  }

  else if(cur === 1){
    p.innerHTML = '<h2>Le dessus 🎨</h2>'
                + '<div class="sub">La grande surface, celle qu’on voit en premier. En simili-cuir, '
                + 'ou en alcantara noir : il accroche mieux et ne brille pas au soleil.</div>';
    p.appendChild(mklabel('Matière et couleur'));
    p.appendChild(nuancier('dessus', C.dessus.s, function(v){ C.dessus.s = v; touch('dessus'); render(); }));
  }

  else if(cur === 2){
    p.innerHTML = '<h2>Les côtés 🔻</h2>'
                + '<div class="sub">Le flanc de la selle et son arrondi, en simili-cuir. Même couleur pour un bloc net, '
                + 'deux couleurs pour souligner la ligne.</div>';
    p.appendChild(mklabel('Côté'));
    p.appendChild(nuancier('cote', C.cote.s, function(v){ C.cote.s = v; touch('cotes'); render(); }));
    p.appendChild(mklabel('Côté arrondi'));
    p.appendChild(nuancier('cote-arrondi', C.arrondi.s, function(v){ C.arrondi.s = v; touch('cotes'); render(); }));
  }

  else if(cur === 3){
    p.innerHTML = '<h2>La surpiqûre 🪡</h2>'
                + '<div class="sub">Le fil qui suit les coutures de la selle. Assorti, il disparaît ; '
                + 'contrasté, il redessine la forme.</div>';
    p.appendChild(mklabel('Couleur du fil'));
    p.appendChild(nuancier('surpiqure', C.surpiqure.s, function(v){ C.surpiqure.s = v; touch('surpiqure'); render(); }));
  }

  else if(cur === 4){
    p.innerHTML = '<h2>Le logo BKS 🅱️</h2>'
                + '<div class="sub">Il signe la selle. Ton sur ton pour rester sobre, ou franc pour qu’on le voie de loin.</div>';
    p.appendChild(mklabel('Couleur du logo'));
    p.appendChild(nuancier('logobks', C.logo.s, function(v){ C.logo.s = v; touch('logo'); render(); }));
  }

  else if(cur === 5){
    p.innerHTML = '<h2>Les broderies 🧵</h2>'
                + '<div class="sub">Ton numéro à l’avant, ton pseudo à l’arrière. Au fil, pas imprimé : ça ne s’effacera jamais.</div>';
    function boiteBrod(titre, prix, etat, ph, lim){
      var box = document.createElement('div'); box.className = 'brodbox';
      box.innerHTML = '<div class="bt"><span>' + titre + '</span><span class="bp">+' + eur(prix) + '</span></div>';
      var inp = document.createElement('input');
      inp.type = 'text'; inp.maxLength = lim; inp.placeholder = ph; inp.value = etat.t;
      inp.oninput = function(){ etat.t = this.value; paint(); };
      box.appendChild(inp);
      box.appendChild(mklabel('Couleur du fil'));
      var w = document.createElement('div'); w.className = 'sws';
      FILBROD.forEach(function(f){
        var s = document.createElement('div');
        s.className = 'sw mini' + (etat.c === f[1] ? ' sel' : '');
        s.style.background = f[1]; s.title = f[0];
        s.onclick = function(){ etat.c = f[1]; render(); };
        w.appendChild(s);
      });
      box.appendChild(w);
      p.appendChild(box);
    }
    boiteBrod('Numéro — avant', PRIX.brodNum, C.brodNum, 'Ex : 04', BROD.num.lim);
    p.appendChild(mklabel('Logo réseau social (brodé devant le pseudo, offert)'));
    var sr = document.createElement('div'); sr.className = 'sws';
    SOC.forEach(function(so){
      var x = document.createElement('div'); x.className = 'swx';
      var d = document.createElement('div'); d.className = 'sw' + (C.social === so[1] ? ' sel' : '');
      if(so[2]) d.setAttribute('style', 'background:#fff url(' + SOC_IMG + so[2] + '.webp) center/72% no-repeat;');
      else { d.setAttribute('style', 'display:flex;align-items:center;justify-content:center;color:#8a8a8a;font-size:18px;'); d.textContent = '∅'; }
      d.onclick = function(){ C.social = so[1]; render(); };
      var l = document.createElement('div'); l.className = 'swlab'; l.textContent = so[0];
      x.appendChild(d); x.appendChild(l); sr.appendChild(x);
    });
    p.appendChild(sr);
    boiteBrod('Pseudo — arrière', PRIX.brodPse, C.brodPse, 'Ex : TON PSEUDO', BROD.pse.lim);
    var nb2 = document.createElement('div'); nb2.className = 'note';
    nb2.innerHTML = 'Laisse vide si tu n’en veux pas — rien n’est facturé.';
    p.appendChild(nb2);
    C.touched.brod = true;
  }

  else {
    p.innerHTML = '<h2>Ta selle 🧾</h2><div class="sub">Vérifie avant d’ajouter au panier.</div>';
    var rb = document.createElement('div'); rb.className = 'recap';
    lignes().forEach(function(l){
      var r = document.createElement('div'); r.className = 'rl';
      r.innerHTML = '<span>' + l[0] + '</span><b>' + l[1] + '</b>';
      rb.appendChild(r);
    });
    var det = [['Housse sur mesure', eur(prixSelle())]];
    if(pDessus())  det.push(['Dessus alcantara', '+ ' + eur(pDessus())]);
    if(pBrodNum()) det.push(['Broderie numéro', '+ ' + eur(pBrodNum())]);
    if(pBrodPse()) det.push(['Broderie pseudo', '+ ' + eur(pBrodPse())]);
    if(pPack())    det.push(['Pack entretien', '+ ' + eur(pPack())]);
    det.forEach(function(d){
      var r = document.createElement('div'); r.className = 'rl';
      r.innerHTML = '<span>' + d[0] + '</span><b>' + d[1] + '</b>';
      rb.appendChild(r);
    });
    var tr = document.createElement('div'); tr.className = 'rr';
    tr.innerHTML = '<span style="font-weight:800">Total</span><b style="font-size:17px">' + eur(total()) + '</b>';
    rb.appendChild(tr);
    p.appendChild(rb);
    [].forEach.call(rb.querySelectorAll('.rl'), function(r){
      r.style.cssText = 'display:flex;justify-content:space-between;gap:12px;font-size:13px;padding:5px 0;border-bottom:1px solid rgba(255,255,255,.05);';
      var vb = r.querySelector('b'); if(vb) vb.style.textAlign = 'right';
    });
    if(BKS_V2) p.appendChild(dansTonPanierV2());

    var up = document.createElement('div'); up.className = 'upsell';
    up.innerHTML = '<div class="ubadge">🔥 -10% à ne pas manquer</div>'
      + '<div class="uimg" style="background-image:url(' + SCDN + 'sc-accessoires-pack-nettoyage.webp)"></div>'
      + '<div class="ubody"><div class="utitle">Pack entretien — garde ta selle comme au premier jour ✨</div>'
      + '<div class="usub">2 microfibres + nettoyant simili/alcantara + nourrissant simili.</div>'
      + '<div class="uprice"><s>19,80 €</s>' + eur(PRIX.pack) + '</div></div>'
      + '<button class="ubtn" id="upb">' + (C.pack ? '✓ Ajouté' : '+ Ajouter') + '</button>';
    p.appendChild(up);
    $('upb').onclick = function(){ C.pack = !C.pack; render(); };
  }

  paint();
  var maxY = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
  window.scrollTo(0, Math.min(y, maxY));
}

/* ---------- récapitulatif (= propriétés de la commande, lues par l'atelier) ---------- */
function lignes(){
  var L = [];
  L.push(['Modèle', C.modele || '—']);
  L.push(['Dessus', nomFin('dessus', C.dessus.s)]);
  L.push(['Côté', nomFin('cote', C.cote.s)]);
  L.push(['Côté arrondi', nomFin('cote-arrondi', C.arrondi.s)]);
  L.push(['Surpiqûre', nomFin('surpiqure', C.surpiqure.s)]);
  L.push(['Logo BKS', nomFin('logobks', C.logo.s)]);
  if(C.brodNum.t.trim()) L.push(['Broderie avant (numéro)', '« ' + C.brodNum.t.trim() + ' » · fil ' + nomFilBrod(C.brodNum.c)]);
  if(C.social !== 'aucun') L.push(['Logo réseau brodé', nomSoc(C.social)]);
  if(C.brodPse.t.trim()) L.push(['Broderie arrière (pseudo)', '« ' + C.brodPse.t.trim() + ' » · fil ' + nomFilBrod(C.brodPse.c)]);
  if(C.pack) L.push(['Pack entretien', eur(PRIX.pack)]);
  return L;
}

function stepDone(i){
  if(i === 0) return C.touched.modele && !!C.modele;
  if(i === 1) return C.touched.dessus;
  if(i === 2) return C.touched.cotes;
  if(i === 3) return C.touched.surpiqure;
  if(i === 4) return C.touched.logo;
  if(i === 5) return C.touched.brod;
  return false;
}
function manque(){
  if(!C.modele)            return { step:0, msg:'Choisis ton modèle de moto 🏍️' };
  if(!C.touched.dessus)    return { step:1, msg:'Choisis la couleur du dessus 🎨' };
  if(!C.touched.cotes)     return { step:2, msg:'Choisis les couleurs des côtés 🔻' };
  if(!C.touched.surpiqure) return { step:3, msg:'Choisis la couleur de la surpiqûre 🪡' };
  if(!C.touched.logo)      return { step:4, msg:'Choisis la couleur du logo 🅱️' };
  return null;
}

function props(id){
  var p = {};
  lignes().forEach(function(l){ p[l[0]] = l[1]; });
  delete p['Pack entretien'];
  p['_bks_id'] = id;
  p['_bks_role'] = 'base';
  return p;
}

/* @@BKS_V2_DONNEES_DEBUT@@ — écrit par construire/K4-injecter.js (inventaire + API + interrupteurs.json) : ne pas modifier à la main */
var BKS_V2 = true;
var BKS_CAT = {"cfg":"LABKS","handle":"option-perso-labks","opts":{"dessus:alcantara-noir":{"v":55306375463253,"p":5000,"t":"Dessus / Alcantara noir"},"brodpse":{"v":55306375496021,"p":3500,"t":"Broderie pseudo / Texte brodé"},"brodnum":{"v":55306661691733,"p":2000,"t":"Broderie numéro / Texte brodé"}},"selles":{},"pack":{"v":54119771603285,"p":1782}};
/* les prix des selles viennent de la fiche (Liquid) : la selle vendue = celle que la fiche affiche */
BKS_CAT.selles = {}; L0.variantes.forEach(function(v){ BKS_CAT.selles[String(v.id)] = v.p; });
/* @@BKS_V2_DONNEES_FIN@@ */
/* @@BKS_V2_DEBUT@@ */
/* ===== BKS configurateurs v2 — bloc COMMUN (08/10/2026). Source unique : site/outils/0810/configurateurs/construire/src/bks-v2-commun.js
   Injecté À L'OCTET par K4-injecter.js dans bks-fusion.js, bks-scooter.js, bks-velto.js, bks-cross.js, bks-selle-custom-v2.js,
   APRÈS le bloc de données (BKS_V2, BKS_CAT), dans la même portée. Aucune donnée propre à un configurateur ici.
   Rôle : ajouter au panier la selle + UNE ligne par option payante (vrai produit « Option de personnalisation · Selle … »,
   quantité 1, au prix de sa variante, imbriquée sous la selle par parent_id ET reliée par _bks_id), en UN SEUL POST /cart/add.js
   (crochet de bks-src.js). L'argent ne dépend jamais de l'imbrication (repli à plat sur un 422).
   API (appelée par addToCartV2() de chaque configurateur) :
     bksV2Envoyer({
       selle: <id de variante de la selle>, prixSelle: <euros, prix du CODE : BASE / PRIX.base / palier>,
       props: <objet rendu par fusProps()/props()/buildProps(), avec _bks_id et _bks_role='base'> (on y AJOUTE les clés cachées),
       cles: [{ cle:'dessus:carbone-noir', p:<euros, prix du CODE pour cette option>, props:{'Texte brodé':'…'}, slot:'b1' }, …],
       pack: <true si le pack entretien est coché : ligne DÉTACHÉE>, total: <total() affiché, en euros, pack compris>,
       lien: <lien de reprise à poser en « _Lien config » s'il manque (SCOOTER, CUSTOM)>,
       brique: function(extra){ … }   chemin brique d'aujourd'hui (addToCartBrique), appelé si un prix diffère ou si les options ne
                                      sont plus achetables (extra = {_bks_repli:'ecart'|'indispo', _bks_cfg, _bks_id} : MÊME n° de selle),
       ok: function(reponse){ … }     après l'ajout (redirection /cart, ou fenêtre CUSTOM),
       ko: function(){ … }            échec (bouton réactivé + message d'aujourd'hui),
       refus: function(msg){ … }      option introuvable au catalogue (finition qui n'est plus proposée) — rien n'est ajouté,
       avertir: function(msg, suite){ … }  écart découvert APRÈS l'ajout : message au client, puis suite() (défaut : alert)
     })
     bksV2Lignes(cles, pack) -> [{ cle, titre, prix (centimes), image }]   lignes exactes qui iront au panier (récapitulatif)
     bksV2Prix()             -> Promise des prix réels { idVariante: centimes } (lus une fois sur /products/<handle>.js)
     bksV2Txt(cle, a, b)     -> message au client dans la langue de la boutique (fr, de, es, it, sinon en)
     bksV2PackLie(cart, gid) -> 1re ligne de pack entretien posée AVEC la configuration gid (_bks_pack_de), ou null
   09/10/2026 (tour 2 des vérificateurs) :
     · le pack détaché porte _bks_pack_de=<_bks_id> : ce n'est PAS _bks_id (gardien et rendu le traitent toujours comme un article
       à part), mais « Modifier ma configuration » sait quel pack venait de l'ancienne configuration (pack décoché = pack retiré) ;
     · « Contrôle atelier <_bks_id> » et « _bks_ecart_<_bks_id> » : un attribut PAR selle (un 2e repli n'écrase plus le 1er) ; le
       gardien v2 efface ceux dont la selle n'est plus au panier ;
     · messages traduits selon Shopify.locale ; lecture des prix au 1er geste du client, plus au chargement de la page.
   10/10/2026 (tour 3 des vérificateurs, défauts M1 et M2) :
     · M1 — le repli brique reçoit _bks_id = le n° de selle de la configuration : addToCartBrique le reprend au lieu d'en fabriquer
       un neuf, donc l'attribut « Contrôle atelier <_bks_id> » suit SA selle et le gardien ne l'efface plus sur /cart ;
     · M2 — options plus achetables (produit d'options archivé, retiré de la Boutique en ligne, variante supprimée ou épuisée,
       X-retour joué trop tôt) : la vente se fait au modèle brique (_bks_repli=indispo), avec « Contrôle atelier <_bks_id> »,
       au lieu d'un « L'ajout au panier a échoué ». Détecté AVANT l'envoi (/products/<handle>.js en 404, variante absente ou
       available=false) ou APRÈS (POST imbriqué refusé 404/422 PUIS renvoi à plat refusé 404/422 : lignes du groupe nettoyées).
       a.ko() ne sert plus qu'à une vraie panne (réseau, 5xx, 429). Sans option payante, rien ne change (pas de produit d'options).
   12/10/2026 (tour 4 des vérificateurs, défaut 5) :
     · marché HORS TVA (Tunisie, Wallis-et-Futuna… : Shopify y sert TOUS les prix ÷ 1,2, TVA française retirée) : ce n'est plus
       un « écart ». Avant : chaque vente de ces pays repassait en briques ×N avec un faux « Contrôle atelier : prix du site ≠
       prix de l'admin ». Désormais, si CHAQUE option vaut exactement son prix d'admin ÷ 1,2 (au centime près) et que le code
       vaut l'admin, la vente se fait en v2 ; après l'ajout, la selle ET chaque option doivent valoir leur prix ÷ 1,2 (sinon :
       écart, comme avant). Tout autre écart de prix reste un écart. L'affichage HT de ces pays reste une décision de Ludo.
   ===== */
var BKS_V2_PRIX = null, BKS_V2_IMG = {}, BKS_V2_DISPO = null;
var BKS_V2_T = {
  fr:{ refus:'Cette finition n’est plus proposée : choisis-en une autre.', echec:'L’ajout au panier a échoué. Réessaie, et préviens-nous si ça persiste.',
       ecart:'Le total de ton panier ({a} €) diffère du total affiché ({b} €). C’est le montant du panier qui sera payé. L’écart est noté sur ta commande pour l’atelier.' },
  de:{ refus:'Diese Ausführung wird nicht mehr angeboten: Bitte wähle eine andere.', echec:'Das Hinzufügen zum Warenkorb ist fehlgeschlagen. Bitte versuche es erneut und sag uns Bescheid, wenn es weiterhin nicht klappt.',
       ecart:'Die Summe deines Warenkorbs ({a} €) weicht von der angezeigten Summe ({b} €) ab. Bezahlt wird der Betrag des Warenkorbs. Die Abweichung wird für die Werkstatt auf deiner Bestellung vermerkt.' },
  es:{ refus:'Este acabado ya no está disponible: elige otro.', echec:'No se ha podido añadir al carrito. Vuelve a intentarlo y avísanos si sigue fallando.',
       ecart:'El total de tu carrito ({a} €) es distinto del total mostrado ({b} €). Se pagará el importe del carrito. La diferencia queda anotada en tu pedido para el taller.' },
  it:{ refus:'Questa finitura non è più disponibile: scegline un’altra.', echec:'L’aggiunta al carrello non è riuscita. Riprova e avvisaci se il problema persiste.',
       ecart:'Il totale del tuo carrello ({a} €) è diverso dal totale mostrato ({b} €). Verrà pagato l’importo del carrello. La differenza è annotata sul tuo ordine per il laboratorio.' },
  en:{ refus:'This finish is no longer available: please choose another one.', echec:'Adding to cart failed. Please try again, and let us know if it keeps happening.',
       ecart:'Your cart total ({a} €) differs from the displayed total ({b} €). The cart amount is what will be charged. The difference is noted on your order for the workshop.' }
};
function bksV2Txt(cle, a, b){
  var l = 'fr';
  try { l = String((window.Shopify && window.Shopify.locale) || document.documentElement.lang || 'fr').slice(0, 2).toLowerCase(); } catch(e){}
  var d = BKS_V2_T[l] || BKS_V2_T.en;
  return String(d[cle] || BKS_V2_T.fr[cle] || '').replace('{a}', a === undefined ? '' : a).replace('{b}', b === undefined ? '' : b);
}
function bksV2PackLie(cart, gid){
  var l = null;
  if(!gid || !BKS_CAT.pack) return null;
  ((cart && cart.items) || []).forEach(function(it){ var p = it.properties || {}; if(!l && String(it.variant_id) === String(BKS_CAT.pack.v) && !p._bks_id && p._bks_pack_de === gid) l = it; });
  return l;
}
function bksV2Prix(){
  if(BKS_V2_PRIX) return BKS_V2_PRIX;
  BKS_V2_PRIX = fetch('/products/' + BKS_CAT.handle + '.js', { cache:'no-cache', headers:{ 'Accept':'application/json' } })
    .then(function(r){ if(r.status === 404) BKS_V2_DISPO = { produit:false, v:{} }; if(!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
    .then(function(j){
      var m = {}, d = {};
      (j.variants || []).forEach(function(v){ m[String(v.id)] = v.price; d[String(v.id)] = v.available !== false; if(v.featured_image && v.featured_image.src) BKS_V2_IMG[String(v.id)] = v.featured_image.src; });
      BKS_V2_DISPO = { produit:true, v:d };
      return m;
    })
    .catch(function(){ return null; });   /* échec (hors 404, noté ci-dessus) : le catalogue embarqué fait foi */
  return BKS_V2_PRIX;
}
function bksV2Cent(x){ return Math.round(Number(x) * 100); }
/* prix servi (centimes) = prix d'admin (centimes) ÷ 1,2 au centime près : marché hors TVA (12/10, défaut 5) */
function bksV2HorsTva(servi, admin){ return typeof servi === 'number' && servi !== admin && Math.abs(servi - Math.round(admin / 1.2)) <= 1; }
function bksV2Lignes(cles, pack){
  var out = [];
  (cles || []).forEach(function(c){ var o = BKS_CAT.opts[c.cle]; if(o) out.push({ cle:c.cle, titre:o.t, prix:o.p, image:BKS_V2_IMG[String(o.v)] || '' }); });
  if(pack && BKS_CAT.pack) out.push({ cle:'pack', titre:'Pack entretien', prix:BKS_CAT.pack.p, image:'' });
  return out;
}
function bksV2Envoyer(a){
  var cat = BKS_CAT, props = a.props || {}, id = props._bks_id;
  var avertir = a.avertir || function(m, suite){ try{ alert(m); }catch(e){} suite(); };
  if(!id || props._bks_role !== 'base'){ a.ko(); return; }
  /* 1. chaque option doit exister au catalogue */
  var lignes = [], manque = null;
  (a.cles || []).forEach(function(c){ var o = cat.opts[c.cle]; if(!o){ manque = manque || c.cle; return; } lignes.push({ c:c, o:o }); });
  if(manque){ a.refus(bksV2Txt('refus')); return; }
  /* repli au modèle brique (10/10, M1 + M2) : attribut « Contrôle atelier <id> » lisible par Micka dans la commande (Détails
     supplémentaires, jamais montré au client), puis addToCartBrique avec le MÊME n° de selle (_bks_id), _bks_repli et _bks_cfg.
     L'ajout brique part ensuite, que l'attribut ait pu être écrit ou non. Le client paie exactement ce qu'il voit. */
  var repli = function(motif, detail){
    try{ window.__bksCfgEcart = { id:id, cfg:cat.cfg, motif:motif, ecarts:detail, le:new Date().toISOString() }; }catch(e){}
    var note = {};
    note['Contrôle atelier ' + id] = motif === 'indispo'
      ? cat.cfg + ' ' + id + ' : options « ' + cat.handle + ' » non achetables (' + detail.slice(0, 3).join(' ; ') + ') — selle ajoutée au modèle brique, prix payé = prix affiché : remettre le produit d’options en vente (prévenir Ludo)'
      : cat.cfg + ' ' + id + ' : prix du site ≠ prix de l’admin (' + detail.slice(0, 3).join(' ; ') + ') — selle ajoutée au modèle brique : vérifier le prix avant fabrication';
    fetch('/cart/update.js', { method:'POST', headers:{ 'Content-Type':'application/json', 'Accept':'application/json' }, body:JSON.stringify({ attributes:note }) })
      .catch(function(){}).then(function(){ a.brique({ _bks_repli:motif, _bks_cfg:cat.cfg, _bks_id:id }); });
  };
  bksV2Prix().then(function(reels){
    /* 2a. options achetables ? (10/10, M2) : produit d'options en 404, variante absente de /products/<handle>.js ou épuisée */
    var indispo = [];
    if(lignes.length && BKS_V2_DISPO){
      if(!BKS_V2_DISPO.produit) indispo.push('/products/' + cat.handle + '.js 404');
      else lignes.forEach(function(l){
        var k = String(l.o.v);
        if(!reels || reels[k] === undefined) indispo.push(l.c.cle + ' : variante ' + k + ' absente');
        else if(BKS_V2_DISPO.v[k] === false) indispo.push(l.c.cle + ' : variante ' + k + ' épuisée');
      });
    }
    if(indispo.length){ repli('indispo', indispo); return; }
    /* 2b. prix AVANT l'ajout : code = variante (réelle, sinon embarquée) ; selle = embarqué ; Σ = total affiché − pack */
    var ecart = [], somme = 0, ps = cat.selles[String(a.selle)];
    if(ps === undefined || bksV2Cent(a.prixSelle) !== ps) ecart.push('selle ' + a.prixSelle + '≠' + ps);
    somme += bksV2Cent(a.prixSelle);
    /* 12/10 (défaut 5) : marché hors TVA = TOUTES les options à leur prix d'admin ÷ 1,2, code = admin */
    var htva = !!reels && lignes.length > 0 && lignes.every(function(l){ var r = reels[String(l.o.v)]; return bksV2Cent(l.c.p) === l.o.p && bksV2HorsTva(r, l.o.p); });
    lignes.forEach(function(l){
      var reel = (reels && reels[String(l.o.v)] !== undefined) ? reels[String(l.o.v)] : l.o.p;
      if(!htva && (bksV2Cent(l.c.p) !== reel || l.o.p !== reel)) ecart.push(l.c.cle + ' ' + bksV2Cent(l.c.p) + '/' + l.o.p + '/' + reel);
      somme += bksV2Cent(l.c.p);
    });
    var attenduTotal = bksV2Cent(a.total) - (a.pack ? cat.pack.p : 0);
    if(somme !== attenduTotal) ecart.push('total ' + somme + '≠' + attenduTotal);
    if(ecart.length){ repli('ecart', ecart); return; }   /* 09/10 (tour 1) : repli non silencieux ; 10/10 (M1) : même n° de selle */
    /* 3. la charge : selle (clés cachées AJOUTÉES), une ligne par option, pack détaché */
    var compte = {};
    lignes.forEach(function(l){ compte[l.o.v] = (compte[l.o.v] || 0) + 1; });
    props._bks_v = '2'; props._bks_cfg = cat.cfg;
    props._bks_opts = Object.keys(compte).sort().map(function(v){ return v + ':' + compte[v]; }).join(';') || 'aucune';
    props._bks_total = String(somme);
    props._bks_parts = String(1 + lignes.length); props._bks_brickqty = '0';
    if(a.lien && !props['_Lien config']) props['_Lien config'] = a.lien;
    var items = [{ id:a.selle, quantity:1, properties:props }];
    lignes.forEach(function(l){
      var p = { _bks_id:id, _bks_role:'opt', _bks_cle:l.c.cle };
      if(l.c.slot) p._bks_slot = l.c.slot;
      if(l.c.props) for(var k in l.c.props) if(l.c.props.hasOwnProperty(k) && l.c.props[k]) p[k] = l.c.props[k];
      items.push({ id:l.o.v, quantity:1, parent_id:a.selle, properties:p });
    });
    if(a.pack && cat.pack) items.push({ id:cat.pack.v, quantity:1, properties:{ _bks_pack_de:id } });
    var poster = function(its){ return fetch('/cart/add.js', { method:'POST', headers:{ 'Content-Type':'application/json', 'Accept':'application/json' }, body:JSON.stringify({ items:its }) }); };
    /* nettoyage d'un ajout partiel : les lignes du groupe (_bks_id) et le pack relié (_bks_pack_de) */
    var nettoyer = function(){
      return fetch('/cart.js', { cache:'no-cache', headers:{ 'Accept':'application/json' } }).then(function(c){ return c.json(); }).then(function(c){
        var u = {}, n = 0;
        (c.items || []).forEach(function(it){ var p = it.properties || {}; if(p._bks_id === id || p._bks_pack_de === id){ u[it.key] = 0; n++; } });
        return n ? fetch('/cart/update.js', { method:'POST', headers:{ 'Content-Type':'application/json', 'Accept':'application/json' }, body:JSON.stringify({ updates:u }) }) : null;
      });
    };
    var refuse = function(st){ return st === 422 || st === 404; };   /* refus de Shopify (variante introuvable, épuisée…), pas une panne */
    /* 4. UN seul POST ; sur un refus (404/422) de la charge imbriquée : nettoyage, UN renvoi à plat ; si le renvoi à plat est refusé
       aussi (10/10, M2) : nettoyage puis repli brique « indispo ». Toute autre réponse (5xx, 429, réseau) : a.ko(). */
    poster(items).then(function(r){
      if(r.ok) return r.json();
      if(!refuse(r.status)) throw new Error('add ' + r.status);
      var st1 = r.status;
      return nettoyer().then(function(){
        var plat = items.map(function(it){ var x = { id:it.id, quantity:it.quantity }; if(it.properties) x.properties = it.properties; return x; });
        plat[0].properties._bks_imbrique = '0';
        return poster(plat).then(function(r2){
          if(r2.ok) return r2.json();
          if(!refuse(r2.status)) throw new Error('add à plat ' + r2.status);
          var st2 = r2.status;
          return nettoyer().then(function(){ return { __bksIndispo:'POST imbriqué ' + st1 + ' puis à plat ' + st2 }; });
        });
      });
    }).then(function(rep){
      if(rep && rep.__bksIndispo){ repli('indispo', [rep.__bksIndispo]); return; }
      /* 5. contrôle APRÈS l'ajout, sur la réponse : prix de la selle et Σ des lignes du groupe */
      var its = (rep && rep.items) || [], trouve = 0, selle = null;
      its.forEach(function(it){ var p = it.properties || {}; if(p._bks_id !== id) return; trouve += it.original_line_price; if(p._bks_role === 'base') selle = it; });
      var bon = selle && selle.original_price === ps && trouve === somme;
      /* 12/10 (défaut 5) : marché hors TVA — la selle ET chaque option du groupe à leur prix d'admin ÷ 1,2, aucune option manquante */
      if(!bon && selle && bksV2HorsTva(selle.original_price, ps)){
        var nOpt = 0, htOk = true;
        its.forEach(function(it){
          var p = it.properties || {}; if(p._bks_id !== id || p._bks_role === 'base') return;
          var o = null; lignes.forEach(function(l){ if(!o && String(l.o.v) === String(it.variant_id)) o = l.o; });
          nOpt += it.quantity || 1;
          if(!o || !bksV2HorsTva(it.original_price, o.p)) htOk = false;
        });
        bon = htOk && nOpt === lignes.length;
      }
      if(bon){ a.ok(rep); return; }
      var attr = {}; attr['_bks_ecart_' + id] = id + ':' + somme + ':' + trouve;
      fetch('/cart/update.js', { method:'POST', headers:{ 'Content-Type':'application/json', 'Accept':'application/json' }, body:JSON.stringify({ attributes:attr }) })
        .catch(function(){}).then(function(){
          avertir(bksV2Txt('ecart', (trouve / 100).toFixed(2).replace('.', ','), (somme / 100).toFixed(2).replace('.', ',')), function(){ a.ok(rep); });
        });
    }).catch(function(){ a.ko(); });
  });
}
/* prix et vignettes des options : lus au 1er geste du client (clic, toucher, touche), pas au chargement de la page ; chaque
   récapitulatif « Dans ton panier » et chaque ajout appellent aussi bksV2Prix() (une seule lecture, mise en cache). */
if(BKS_V2){
  (function(){
    var T = ['pointerdown', 'touchstart', 'keydown'], fait = false;
    function go(){ if(fait) return; fait = true; T.forEach(function(t){ document.removeEventListener(t, go, true); }); bksV2Prix(); }
    T.forEach(function(t){ document.addEventListener(t, go, { capture:true, passive:true }); });
  })();
}
try { window.__BKS_CFG2_COMMUN = { version:'2026-10-12-t4', cfg:BKS_CAT.cfg, v2:BKS_V2 }; } catch(e) {}
/* @@BKS_V2_FIN@@ */


var ETAPE_V2 = { dessus:1, brodnum:5, brodpse:5 };
function texteV2(nom){
  var L = lignes();
  for(var i = 0; i < L.length; i++) if(L[i][0] === nom) return L[i][1];
  return '';
}
function optsV2(){
  var o = [];
  if(pDessus())  o.push({ cle:'dessus:' + C.dessus.s, p:pDessus() });
  if(pBrodNum()) o.push({ cle:'brodnum', p:pBrodNum(), props:{ 'Texte brodé':texteV2('Broderie avant (numéro)') } });
  if(pBrodPse()) o.push({ cle:'brodpse', p:pBrodPse(), props:{ 'Texte brodé':texteV2('Broderie arrière (pseudo)') } });
  return o;
}
function addToCartV2(v){
  var btn = $('bn'); btn.disabled = true; btn.textContent = 'Ajout…';
  var rendre = function(){ btn.disabled = false; btn.textContent = '🛒 Ajouter au panier'; };
  var cles = optsV2();
  bksV2Envoyer({
    selle: v, prixSelle: prixSelle(), props: props('LBK-' + Date.now()), cles: cles, pack: C.pack, total: total(),
    brique: function(extra){ addToCartBrique(extra); },
    ok: function(){ window.location.href = '/cart'; },
    ko: function(){ rendre(); alert(bksV2Txt('echec')); },
    refus: function(msg){
      rendre();
      var e = STEPS.length - 1;
      for(var i = 0; i < cles.length; i++) if(!BKS_CAT.opts[cles[i].cle]){ e = ETAPE_V2[cles[i].cle.split(':')[0]]; break; }
      cur = (e === undefined) ? STEPS.length - 1 : e; render(); window.scrollTo({ top:0, behavior:'smooth' });
      alert(msg);
    }
  });
}
/* « Dans ton panier » : les lignes EXACTES qui iront au panier */
function dansTonPanierV2(){
  var box = document.createElement('div'); box.className = 'recap'; box.id = 'bks-v2-panier';
  box.style.marginTop = '12px';
  var h = document.createElement('div'); h.className = 'lb'; h.style.margin = '0 0 8px'; h.textContent = 'Dans ton panier';
  box.appendChild(h);
  var ligne = function(img, titre, sous, prix, retrait){
    var r = document.createElement('div');
    r.style.cssText = 'display:flex;align-items:center;gap:10px;padding:6px 0;border-bottom:1px solid rgba(255,255,255,.05);font-size:13px;' + (retrait ? 'padding-left:14px;' : '');
    var t = document.createElement('div'); t.style.cssText = 'flex:1;min-width:0;line-height:1.3;';
    var tt = document.createElement('div'); tt.textContent = titre; t.appendChild(tt);
    if(sous){ var ts = document.createElement('div'); ts.style.cssText = 'font-size:12px;color:var(--txt2);'; ts.textContent = sous; t.appendChild(ts); }
    if(img !== null){
      var im = document.createElement('img'); im.alt = ''; im.width = 34; im.height = 34;
      im.style.cssText = 'width:34px;height:34px;flex:0 0 34px;border-radius:7px;object-fit:cover;background:#2a2a32;';
      if(img.src) im.src = img.src; else if(img.v) im.setAttribute('data-bks-v2-v', String(img.v));
      r.appendChild(im);
    }
    r.appendChild(t);
    var b = document.createElement('b'); b.style.cssText = 'font-weight:700;white-space:nowrap;'; b.textContent = prix; r.appendChild(b);
    box.appendChild(r);
  };
  ligne(null, L0.titre, C.modele || '', eur(prixSelle()), false);
  var cles = optsV2();
  if(cles.length){
    var c = document.createElement('div'); c.style.cssText = 'font-size:12px;color:var(--txt2);padding:6px 0 0 14px;';
    c.textContent = 'Compris dans ta selle (options de personnalisation) :';
    box.appendChild(c);
  }
  cles.forEach(function(k){
    var o = BKS_CAT.opts[k.cle];
    var img = o ? { src:BKS_V2_IMG[String(o.v)] || '', v:o.v } : null;
    var sous = k.props ? (k.props['Texte brodé'] || '') : '';
    ligne(img || { src:'' }, o ? o.t.replace(' / ', ' · ') : k.cle, sous, eur(k.p), true);
  });
  var ts = Math.round(prixSelle() * 100);
  cles.forEach(function(k){ var o = BKS_CAT.opts[k.cle]; ts += o ? o.p : Math.round(Number(k.p) * 100); });
  var trs = document.createElement('div'); trs.className = 'rr';
  trs.innerHTML = '<span style="font-weight:800">Ta selle configurée</span><b>' + eur(ts / 100) + '</b>';
  box.appendChild(trs);
  if(C.pack){
    ligne({ src:SCDN + 'sc-accessoires-pack-nettoyage.webp' }, 'Pack entretien', 'ligne à part · peut recevoir −10 % au panier avec ta selle', eur(PRIX.pack), false);
    var tr = document.createElement('div'); tr.className = 'rr';
    tr.innerHTML = '<span style="font-weight:800">Total avant remise sur le pack</span><b>' + eur(total()) + '</b>';
    box.appendChild(tr);
  }
  bksV2Prix().then(function(){
    [].forEach.call(box.querySelectorAll('img[data-bks-v2-v]'), function(im){
      var s = BKS_V2_IMG[im.getAttribute('data-bks-v2-v')]; if(s) im.src = s;
    });
  });
  return box;
}
try { window.__BKS_CFG2_TEST = { cfg:'LABKS', etat:C, optsV2:optsV2, total:total, props:props, lignes:lignes, variante:variante,
  aller:function(i){ cur = i; render(); } }; } catch(e) {}

function addToCart(){
  var m = manque();
  if(m){ cur = m.step; render(); window.scrollTo({ top:0, behavior:'smooth' }); alert(m.msg); return; }
  var v = variante();
  if(!v){ cur = 0; render(); alert('Choisis ton modèle de moto 🏍️'); return; }
  if(BKS_V2) addToCartV2(v); else addToCartBrique();
}

/* repli « brique » (options indisponibles ou écart de prix) : l'ancien fonctionnement de la LA BKS V2,
   produit « Supplément selle 2D » dont chaque variante vaut un montant (50 €, 35 €) */
function addToCartBrique(extra){
  var v = variante();
  var id = (extra && extra._bks_id) || ('LBK-' + Date.now());
  var btn = $('bn'); btn.disabled = true; btn.textContent = 'Ajout…';
  var echec = function(){ btn.disabled = false; btn.textContent = '🛒 Ajouter au panier';
    alert('L’ajout au panier a échoué. Réessaie, et préviens-nous si ça persiste.'); };
  var supps = [];
  if(pDessus())  supps.push({ amt:pDessus(),  lib:'Dessus : ' + nomFin('dessus', C.dessus.s) });
  if(pBrodNum()) supps.push({ amt:pBrodNum(), lib:'Broderie avant (numéro) : ' + C.brodNum.t.trim() });
  if(pBrodPse()) supps.push({ amt:pBrodPse(), lib:'Broderie arrière (pseudo) : ' + C.brodPse.t.trim() });
  fetch('/products/' + SUPP_HANDLE + '.js', { cache:'no-cache' }).then(function(r){ return r.json(); }).then(function(j){
    var parCents = {}; (j.variants || []).forEach(function(x){ if(x.available !== false) parCents[x.price] = x.id; });
    var items = [{ id:v, quantity:1, properties:props(id) }];
    for(var i = 0; i < supps.length; i++){
      var sv = parCents[Math.round(supps[i].amt * 100)];
      if(!sv) throw new Error('supplément ' + supps[i].amt);
      items.push({ id:sv, quantity:1, properties:{ 'Détail':supps[i].lib, '_bks_id':id, '_bks_role':'supp' } });
    }
    if(C.pack) items.push({ id:PACK_VAR, quantity:1, properties:{ '_bks_id':id, '_bks_role':'supp', 'Détail':'Pack entretien' } });
    items[0].properties['_bks_parts']    = String(items.length);
    items[0].properties['_bks_brickqty'] = '0';
    if(extra) for(var k in extra) if(extra.hasOwnProperty(k)) items[0].properties[k] = extra[k];
    return fetch('/cart/add.js', { method:'POST', headers:{ 'Content-Type':'application/json' }, body: JSON.stringify({ items:items }) });
  }).then(function(r){ if(!r.ok) throw new Error('add ' + r.status); window.location.href = '/cart'; })
    .catch(echec);
}

/* ---------- navigation ---------- */
$('bp').onclick = function(){ if(cur > 0){ cur--; render(); } };
/* 16/10/2026 (diagnostic panier, demande de Ludo) : « Suivant » vaut choix de ce qui est affiché sur l'étape qu'on quitte.
   La pastille par défaut était déjà dessinée « choisie », mais « Ajouter au panier » renvoyait quand même le client
   à l'étape, une alerte à la fois. La vérification finale reste pour les étapes jamais ouvertes. */
var BKS_ETAPE_CHOIX={1:'dessus',2:'cotes',3:'surpiqure',4:'logo',5:'brod'};
function bksAccepterEtape(i){ var k=BKS_ETAPE_CHOIX[i]; if(k)touch(k); }
$('bn').onclick = function(){
  if(cur < STEPS.length-1){ bksAccepterEtape(cur); cur++; render(); return; }
  addToCart();
};

/* ============================================================
   GÉNÉRATEUR DE SELLE — le client range les couleurs de sa moto (de la plus
   présente à la moins présente) ; la 1re va sur le dessus, la 2e sur le côté,
   la 3e sur l'arrondi et la surpiqûre. Deux propositions : simili, et la même
   avec le dessus en alcantara noir quand la couleur principale est le noir.
   ============================================================ */
var genC = [null, null, null];
function paletteSimili(){ return liste('dessus').filter(function(o){ return o.matiere === 'Simili'; }); }
function slugCoul(zone, c){ var l = liste(zone); for(var i=0;i<l.length;i++) if(l[i].couleur === c && l[i].matiere === 'Simili') return l[i].slug; return valide(zone, c); }
function logoSur(c){ return (c === 'blanc' || c === 'jaune' || c === 'gris') ? 'noir' : 'blanc'; }

function renderGenRow(elId, rang){
  var el = $(elId); if(!el) return; el.innerHTML = '';
  paletteSimili().forEach(function(o){
    var w = document.createElement('div'); w.className = 'swx';
    var s = document.createElement('div');
    s.className = 'sw' + (genC[rang] === o.couleur ? ' sel' : '');
    s.style.background = o.hex; s.title = o.nom;
    s.onclick = function(){
      if(genC[rang] === o.couleur) genC[rang] = null;
      else { for(var i = 0; i < 3; i++) if(genC[i] === o.couleur) genC[i] = null; genC[rang] = o.couleur; }
      renderGen();
    };
    var l = document.createElement('div'); l.className = 'swlab'; l.textContent = o.nom;
    w.appendChild(s); w.appendChild(l); el.appendChild(w);
  });
}
function renderGen(){ for(var i = 0; i < 3; i++) renderGenRow('genc' + (i+1), i); }
function genCouleurs(){
  var a = genC.filter(Boolean);
  if(!a.length) return null;
  if(a.length === 3) return a;
  if(a.length === 2) return [a[0], a[1], a[1]];
  return [a[0], a[0], logoSur(a[0])];
}
function composer(alc){
  var c = genCouleurs(); if(!c) return null;
  var cfg = {
    dessus:    (alc && c[0] === 'noir') ? valide('dessus', 'alcantara-noir') : slugCoul('dessus', c[0]),
    cote:      slugCoul('cote', c[1]),
    arrondi:   slugCoul('cote-arrondi', c[2]),
    surpiqure: slugCoul('surpiqure', c[2]),
    logo:      slugCoul('logobks', logoSur(c[0]))
  };
  cfg.price = prixSelle() + prixFin('dessus', cfg.dessus);
  return cfg;
}
function miniPreview(c){
  function u(z, s){ return urlCalque(z, s); }
  return '<img src="' + u('base', 'base') + '" alt=""><img src="' + u('cote-arrondi', c.arrondi) + '" alt="">'
       + '<img src="' + u('cote', c.cote) + '" alt=""><img src="' + u('dessus', c.dessus) + '" alt="">'
       + '<img src="' + u('surpiqure', c.surpiqure) + '" alt=""><img src="' + u('logobks', c.logo) + '" alt="">';
}
function carte(id, badge, titre, c, cls){
  return '<div class="prop' + cls + '"><span class="pb">' + badge + '</span>'
       + '<h4>' + titre + '</h4><div class="pl">' + (prixFin('dessus', c.dessus) ? 'dessus alcantara noir' : 'simili-cuir sur toute la selle') + '</div>'
       + '<div class="pv">' + miniPreview(c) + '</div>'
       + '<div class="rsm">Dessus <b>' + nomFin('dessus', c.dessus) + '</b> · côté <b>' + nomFin('cote', c.cote)
       + '</b> · arrondi <b>' + nomFin('cote-arrondi', c.arrondi) + '</b> · surpiqûre <b>' + nomFin('surpiqure', c.surpiqure) + '</b></div>'
       + '<div class="foot"><span class="prix">' + eur(c.price) + '</span>'
       + '<button class="papp" id="ap-' + id + '">J’applique →</button></div></div>';
}
function propose(){
  var a = composer(false);
  if(!a){ $('props').innerHTML = '<div class="note">Choisis au moins la couleur principale de ta moto 👆</div>'; return; }
  var b = composer(true), deux = prixFin('dessus', b.dessus) > 0;
  $('props').innerHTML = carte('ess', 'ESSENTIELLE', 'Le meilleur prix', a, deux ? '' : ' hi')
                       + (deux ? carte('sig', 'SIGNATURE', 'Dessus alcantara', b, ' hi') : '');
  $('ap-ess').onclick = function(){ appliquer(a); };
  if(deux) $('ap-sig').onclick = function(){ appliquer(b); };
}
function appliquer(cfg){
  C.dessus.s = cfg.dessus; C.cote.s = cfg.cote; C.arrondi.s = cfg.arrondi;
  C.surpiqure.s = cfg.surpiqure; C.logo.s = cfg.logo;
  C.touched.dessus = C.touched.cotes = C.touched.surpiqure = C.touched.logo = true;
  $('gen').classList.remove('on');
  cur = C.modele ? STEPS.length - 1 : 0; render();
  window.scrollTo({ top:0, behavior:'smooth' });
}
(function(){
  var fab = $('genfab'); if(!fab) return;
  var dernier = 0;
  window.addEventListener('scroll', function(){
    var y = window.scrollY || 0;
    fab.classList.toggle('cache', y > dernier + 4 && y > 120);
    dernier = y;
  }, { passive:true });
})();
if($('genfab')){
  $('genfab').onclick   = function(){ $('gen').classList.add('on'); renderGen(); $('props').innerHTML = ''; };
  $('genclose').onclick = function(){ $('gen').classList.remove('on'); };
  $('genGo').onclick    = propose;
}

/* ---------- démarrage ---------- */
C.dessus.s    = valide('dessus', C.dessus.s);
C.cote.s      = valide('cote', C.cote.s);
C.arrondi.s   = valide('cote-arrondi', C.arrondi.s);
C.surpiqure.s = valide('surpiqure', C.surpiqure.s);
C.logo.s      = valide('logobks', C.logo.s);
if(MODELES.length === 1){ C.modele = MODELES[0]; touch('modele'); }   /* fiche à un seul modèle : posé d'office */
render();
})();
